// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2POOH","footer":"ModalCreateQualiphyProcedure_footer__3Nblr","additionData":"ModalCreateQualiphyProcedure_additionData__2xHIQ"};